export default {
	model: {
		prop: "checked",
		event: "change",
	},

	props: {
		checked: [Boolean, String, Number],
		trueValue: { default: true },
		falseValue: { default: false },
	},

	computed: { isChecked },
};

function isChecked() {
	return this.checked === this.trueValue;
}
